import { render, staticRenderFns } from "./UserList.vue?vue&type=template&id=2d2d651e&scoped=true&"
import script from "./UserList.vue?vue&type=script&lang=js&"
export * from "./UserList.vue?vue&type=script&lang=js&"
import style0 from "./UserList.vue?vue&type=style&index=0&id=2d2d651e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d2d651e",
  null
  
)

export default component.exports